import React, { useState, Component } from 'react';
import { Stats } from 'fs';
import LinearProgress from '@material-ui/core/LinearProgress';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';

function StatsFieldFilledOut(props)
{
  const [tooltipOpen, setTooltipOpen] = React.useState(false );
  const handleTourTooltipClose = event => setTooltipOpen(false);

  if (!props.field || (props.field.numActive + props.field.numGuestFilledOut === 0))
    return null;
  let filledOut = props.field.numActiveFilledOut / props.field.numActive;
  return <div><LinearProgress style={{display:"inline-block",width:100}} variant="determinate" value={filledOut*100}/> 
  <ClickAwayListener onClickAway={() => handleTourTooltipClose()}>
            
            <Tooltip
              PopperProps={{
                disablePortal: true,
              }}
              onClose={() => handleTourTooltipClose()}
              open={tooltipOpen}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title={"" + props.field.numActiveFilledOut+"/"+props.field.numActive + " aktive Musiker haben die Umfrage ausgefüllt. " + ((props.field.numGuestFilledOut > 0) ? " Zudem noch "+props.field.numGuestFilledOut +" Gastmuiker.": "")}
            >
              <Button onClick={() => setTooltipOpen(true)}>
              <span fontSize="small">{props.field.numActiveFilledOut}/{props.field.numActive}{props.field.numGuestFilledOut > 0 ? "+"+props.field.numGuestFilledOut : null}</span>
              </Button>
              
            </Tooltip>
        </ClickAwayListener>
  
  </div>;

}


function StatsFieldAvailability(props)
{
  const [tooltipOpen, setTooltipOpen] = React.useState(false );
  

  if (!props.field || (props.field.numActive + props.field.numGuestFilledOut === 0))
    return null;
  let numFilledOut = props.field.numActiveFilledOut + props.field.numGuestFilledOut;
  if (numFilledOut === 0)
    return null;
  return <div><LinearProgress style={{display:"inline-block",width:100}} variant="determinate" value={props.field.totalAvailability/(numFilledOut)*100}/> 
  {/*props.field.totalAvailability/(numFilledOut)*/}
  </div>;

}

export default class SurveyStatistics extends Component {
  static propTypes = {

  };

  render() {

    let roles = {};
    let locationsToIndex = {};
    delete this.props.statistics.Tour;
    Object.keys(this.props.statistics).forEach((loc, idx) => 
    {
      locationsToIndex[loc] = idx;
    });
    for (let location of Object.keys(this.props.statistics))
    {
      let locationStats = this.props.statistics[location];
      for (let role of Object.keys(locationStats))
      {
        if (!roles[role])
        {
          roles[role] = [];
          for (let i=0;i<locationsToIndex.length;i++)
          {
            roles[role].push({});
          }
        }       
        roles[role][locationsToIndex[location]] = locationStats[role];     
      }

    }

    return (
      <div className="worker-config-survey-statistics">
        <h4>So viele Musiker haben bereits teilgenommen.</h4>
        Die Tabelle zeigt, wie viele der aktiven Musiker, die im jeweiligen Standort gerne spielen, schon teilgenommen haben.
           <table  class="table autowidth">
    <thead style={{minWidth:"500px"}}>
    <tr>
        <th class="shorty"></th>
        {Object.keys(this.props.statistics).map(loc => <th class="shorty">{loc}</th>)}        
      </tr>
    </thead>
    <tbody>
      {Object.keys(roles).map(role => <tr><td class="shorty">{role}</td>

      {Object.values(locationsToIndex).map( idx => <td class="shorty">{<StatsFieldFilledOut field={roles[role][idx]} />}</td>)}     
      
      </tr>)}
    </tbody>

</table>

<h4>So hoch ist die Verfügbarkeit der Musiker</h4>
Wenn alle Musiker immer "passt" (grün) angeben, ist der Balken voll. Bei immer "nicht so gerne" (gelb) 75%, immer "nur im Notfall" (orange) 25%, immer "geht nicht" (rot) 0%. 
Mehrere Angaben werden gemittelt. 
           <table  class="table autowidth">
    <thead style={{minWidth:"500px"}}>
    <tr>
        <th class="shorty"></th>
        {Object.keys(this.props.statistics).map(loc => <th class="shorty">{loc}</th>)}        
      </tr>
    </thead>
    <tbody>
      {Object.keys(roles).map(role => <tr><td class="shorty">{role}</td>

      {Object.values(locationsToIndex).map( idx => <td class="shorty">{<StatsFieldAvailability field={roles[role][idx]} />}</td>)}     
      
      </tr>)}
    </tbody>

</table>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/worker-config/SurveyStatistics.js